import styled from 'styled-components';
import { spacing } from 'ui/theme';

export const DestinationCardsWrapper = styled.div`
  gap: ${spacing.base};
  margin-top: ${spacing.base};
  display: grid;
  grid-template-columns: repeat(3, 1fr);
`;
